import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import t from "@ext/localization/locale/translate";
import { Badge } from "@ui-kit/Badge";
import { Tooltip, TooltipContent, TooltipTrigger } from "@ui-kit/Tooltip";

const CardUnpublished = () => {
	const isReadOnly = PageDataContextService.value.conf.isReadOnly;
	if (isReadOnly) return null;

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Badge
					aria-label={t("catalog.unpublished")}
					className="bg-status-neutral-bg-hover"
					data-qa="unpublished-badge"
					size="sm"
					startIcon="cloud-upload"
				/>
			</TooltipTrigger>
			<TooltipContent>{t("catalog.unpublished")}</TooltipContent>
		</Tooltip>
	);
};

export default CardUnpublished;
